import React from 'react';
import Hero from '../components/Hero';
import FeaturedServices from '../components/FeaturedServices';
import './Home.css';

function Home() {
  return (
    <div className="home-page">
      <Hero />
      <FeaturedServices />
    </div>
  );
}

export default Home;
